import { generatePlaceholderSrc } from '@redbubble/design-system/react/Image';

const cache = {};

export default (width, height) => {
  if (typeof document === 'undefined') return null;
  if (!width || !height) return null;

  const ratio = height / width;
  const ratioPercent = Math.floor(ratio * 100);

  const placeholderWidth = 100;
  const placeholderHeight = Math.floor((placeholderWidth * ratioPercent) / 100);

  const key = `${placeholderWidth}x${placeholderHeight}`;

  if (cache[key]) return cache[key];

  const placeholder = generatePlaceholderSrc({
    width: placeholderWidth,
    height: placeholderHeight
  });

  cache[key] = placeholder;

  return placeholder;
};
